
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h30v30H0z"}})])]),_c('g',{attrs:{"data-name":"Artboard – 2","clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"rgba(255,255,255,0)","d":"M0 0h30v30H0z"}}),_c('g',{attrs:{"data-name":"Group 13201","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 32478","d":"M15.023.399a8.97 8.97 0 018.96 8.96 8.852 8.852 0 01-.923 3.947 1 1 0 01-.061.133l-7.1 12.811a1 1 0 01-1.749 0L7.047 13.439a1 1 0 01-.063-.137 8.852 8.852 0 01-.92-3.942A8.97 8.97 0 0115.023.399zm6.175 12.163q.013-.031.028-.061a6.877 6.877 0 00.756-3.142 6.96 6.96 0 10-13.92 0 6.877 6.877 0 00.757 3.14q.016.032.03.065l6.174 11.135z"}}),_c('path',{attrs:{"data-name":"Ellipse 390","d":"M15.023 5.206a4.035 4.035 0 11-4.035 4.035 4.04 4.04 0 014.035-4.035zm0 6.071a2.035 2.035 0 10-2.035-2.036 2.038 2.038 0 002.035 2.036z"}}),_c('path',{attrs:{"data-name":"Path 32479","d":"M15.025 29.602a30.213 30.213 0 01-7.616-.866c-2.511-.685-3.784-1.684-3.784-2.971 0-.89.61-1.647 1.813-2.249a13.824 13.824 0 013.61-1.091 1 1 0 01.361 1.967c-2.568.471-3.537 1.108-3.753 1.372a5.662 5.662 0 002.69 1.148 29.486 29.486 0 006.677.69 29.486 29.486 0 006.678-.69 5.661 5.661 0 002.69-1.148c-.215-.263-1.184-.9-3.752-1.372A1 1 0 1121 22.425a13.821 13.821 0 013.61 1.091c1.2.6 1.812 1.359 1.812 2.249 0 1.286-1.273 2.286-3.782 2.971a30.213 30.213 0 01-7.615.866z"}})])])])
          )
        }
      }
    